import React, { useState, useMemo, useEffect } from 'react';
import styles from './lessonSection.module.scss';
import { Content } from '../../../../types';
import { useCourseContent } from '../../../../hooks/useCourseContent';
import { LastVisitedLessonContentFragment as LastVisitedLesson, Quiz } from 'src/api/graphql-codegen';
import SectionContents from './section-contents/SectionContents';

type Props = {
  title: string;
  contents: Content[];
  quiz: Quiz | undefined;
  lastVisitedLesson?: LastVisitedLesson;
  trackEventName?: string;
  closeNav?: () => void;
};

function QuizSection(props: Props) {
  const { contents = [], quiz, lastVisitedLesson, closeNav } = props;

  const [opened, setOpened] = useState(false);
  const { content: selectedContent, lesson: selectedLesson } = useCourseContent();

  useEffect(() => {
    if (lastVisitedLesson && lastVisitedLesson?.lessonId === quiz?.id) {
      setOpened(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lastVisitedLesson]);

  useEffect(() => {
    if (selectedContent && contents.map(c => c.id).includes(selectedContent.id)) {
      setOpened(true);
    }
  }, [selectedLesson, selectedContent, contents]);

  const wrapperClassName = useMemo(() => {
    const classes = [styles.quizWrapper];
    if (opened) {
      classes.push(styles.opened);
    }

    if (contents.find(c => c.id === selectedContent?.id) && selectedLesson?.id === quiz?.id) {
      classes.push(styles.selected);
    }

    return classes.join(' ');
  }, [opened, selectedContent, contents, quiz, selectedLesson]);

  return (
    <div className={wrapperClassName}>
      <div className={styles.content}>
        <SectionContents contents={contents} lastVisitedLesson={lastVisitedLesson} closeNav={closeNav}/>
      </div>
    </div>
  );
}

export default React.memo(QuizSection);
